import React from 'react'
import { VStack, Alert, AlertIcon, Text, Box } from '@chakra-ui/react'
import { TagRecommendation } from '@/types'
import { ContentTagOptions } from '@/hooks/useContentTagSuggestions'
import { ContentOptionsPanel } from './ContentOptionsPanel'
import { TagSuggestionsList } from './TagSuggestionsList'
import { useAppTranslation } from '@/contexts/LanguageContext'

interface ContentAnalysisTabProps {
  suggestions: TagRecommendation[]
  isLoading: boolean
  error: string | null
  options: ContentTagOptions
  onOptionsChange: (field: keyof ContentTagOptions, value: any) => void
  onAnalyze: () => void
  selectionCount: number
  onToggleTag: (tagName: string) => void
  isTagSelected: (tagName: string) => boolean
}

export function ContentAnalysisTab({
  suggestions,
  isLoading,
  error,
  options,
  onOptionsChange,
  onAnalyze,
  selectionCount,
  onToggleTag,
  isTagSelected,
}: ContentAnalysisTabProps) {
  const hasAnalyzed = suggestions.length > 0 || isLoading || error
  const { t } = useAppTranslation('files')

  return (
    <VStack spacing={4} align="stretch">
      <ContentOptionsPanel
        options={options}
        onOptionsChange={onOptionsChange}
        onAnalyze={onAnalyze}
        isLoading={isLoading}
      />

      {hasAnalyzed ? (
        <TagSuggestionsList
          suggestions={suggestions}
          isLoading={isLoading}
          error={error}
          selectionCount={selectionCount}
          onToggleTag={onToggleTag}
          isTagSelected={isTagSelected}
          loadingText={t('contentAnalysisTab.loadingText')}
          emptyMessage={t('contentAnalysisTab.emptyMessage')}
        />
      ) : (
        <Box bg="blue.50" p={4} borderRadius="lg" border="1px solid" borderColor="blue.200">
          <Alert status="info" variant="subtle" bg="transparent" p={0}>
            <AlertIcon color="blue.500" />
            <Text color="blue.700" fontSize="sm">
              {t('contentAnalysisTab.generateDescription')}
            </Text>
          </Alert>
        </Box>
      )}
    </VStack>
  )
}
